import React from 'react';
import { Box } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';

type ButtonExpansionProps = Readonly<{
    onClick: () => void;
    children: string;
}>;

export const ButtonExpansion = ({ onClick, children }: ButtonExpansionProps) => (
    <Box as="button" onClick={onClick} cursor="pointer">
        <Text fontWeight="semibold" color="bodyPrimary" decoration="underline">
            {children}
        </Text>
    </Box>
);
